<mc-translation-string [name]="CommonString.OkButton" i18n="The text for OK buttons">OK</mc-translation-string>
